export default "/assets/website/components/images/plugin.01df3cd0.svg";